// Example of SVG converted to js array, so it can be used with CIcon.
// the first argument is two last values of svg viewBox,
// the second argument is the SVG content stripped of SVG tags
export const support = ['18 14', `
  <g>
  <path d="M1.37501 2.00059V2.00001C1.37501 1.46537 1.80783 1.03334 2.33334 1.03334H15.6667C16.1967 1.03334 16.6333 1.46994 16.6333 2.00001V12C16.6333 12.5301 16.1967 12.9667 15.6667 12.9667H2.33334C1.80336 12.9667 1.36681 12.5302 1.36667 12.0003C1.36667 12.0002 1.36667 12.0001 1.36667 12L1.37501 2.00059Z" stroke="var(--active-svg-stroke-color, #C2CFE0)" stroke-width="1.4"/>
  <path d="M1.5 2L9 7L16.5 2" stroke="var(--active-svg-stroke-color, #C2CFE0)" stroke-width="1.4"/>
  </g>
`]
